import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { ModalComponent } from '@app/core/services/modal-manager/modal-component';
import { LoginModule } from '@app/pages/login/login.module';
import { RegisterModule } from '@app/pages/register/register.module';
import { TranslateModule } from '@ngx-translate/core';

enum ModalFunctions {
  LOGIN,
  REGISTER,
}

@Component({
  selector: 'app-login-register',
  standalone: true,
  imports: [CommonModule, LoginModule, RegisterModule, TranslateModule],
  templateUrl: './login-register.component.html',
  styleUrl: './login-register.component.scss',
})
export class LoginRegisterComponent extends ModalComponent {
  protected readonly currentFunction = signal<ModalFunctions>(ModalFunctions.LOGIN);
  protected readonly modalFunctions = ModalFunctions;
}
